<template>
  <TWModal
    :title="$t('ui.envelopes.create.outdated.title')"
    :loading="false"
    :show="!!outdatedStep"
    @close="$emit('close')"
    :allow-outside-click-to-close="false"
  >
    <template v-slot:content>
      <p>
        {{ shouldReload ? $t('ui.envelopes.create.outdated.check', { step }) : $t('ui.envelopes.create.outdated.changed', { step }) }}
      </p>
    </template>

    <template v-slot:controls>
      <BaseButton
        v-if="shouldReload"
        @click.native="$emit('reload')"
      >
        {{ $t(`ui.envelopes.create.outdated.reload`, { step }) }}
      </BaseButton>
      <ButtonLink
        v-else
        :to="outdatedRoute"
      >
        {{ $t(`ui.envelopes.create.outdated.goTo`, { step }) }}
      </ButtonLink>
    </template>
  </TWModal>
</template>

<script setup>
// @ts-check

import { computed, onDeactivated } from 'vue';

import { useEnvelopesRoutes } from '@/composables/envelopes';
import i18n from '@/locales';

import BaseButton from '@/components/library/buttons/BaseButton.vue';
import ButtonLink from '@/components/library/links/ButtonLink.vue';
import TWModal from '@/components/tailwind/Modal.vue';

const props = defineProps({
  /** @type {import('vue').PropOptions<import('axios').AxiosError|Error|null>} */
  updateError: {
    required: true,
  },
});

const emit = defineEmits(['close']);

const { currentRoute, progressSteps } = useEnvelopesRoutes();

/** @type {import('vue').ComputedRef<string|undefined>} */
const outdatedStep = computed(() =>
  (props.updateError && 'response' in props.updateError
    ? props.updateError.response?.data?.outdated_step
    : undefined));

const step = computed(() =>
  i18n.t(`ui.envelopes.create.outdated.steps.${outdatedStep.value}`));

const outdatedRoute = computed(() => progressSteps[outdatedStep.value]);
const shouldReload = computed(() => outdatedRoute.value.name === currentRoute.name);

onDeactivated(() => {
  emit('close');
});
</script>
